import React, { Component } from 'react'
import Modal from 'react-modal';
import { connectModal } from 'redux-modal'
import { VERIFY_AGE_DIALOG } from '../../../constants'
import VerifyAgeForm from '../VerifyAgeForm'
import translate from '../../TranslateHOC';

class VerifyAgeDialog extends Component {

    constructor () {
        super();
        this.handleConfirmDialog = this.handleConfirmDialog.bind(this);
    }

    handleConfirmDialog(){
        this.props.handleConfirm();
        this.props.handleHide();
    }

    render() {
        const { show, handleHide } = this.props;

        return (
            <Modal
                isOpen={show}
                overlayClassName="dialog__overlay"
                className="dialog__content"
                onRequestClose={handleHide}
                role="dialog"
                ariaHideApp={true}
                contentLabel={this.props.strings.contentWarningChallenge}>
                <VerifyAgeForm handleCancel={this.props.handleHide} handleConfirm={this.handleConfirmDialog}  contentWarnings={this.props.contentWarnings}/>
            </Modal>
        );
    }
}

export default translate(connectModal(
    {    name: VERIFY_AGE_DIALOG,
        destroyOnHide: true })(VerifyAgeDialog))
